import React, { useState, useEffect, Suspense, lazy } from 'react';
 
// Ленивый импорт highlight.js
const loadHighlight = async () => {
    const [hljsModule, iecstModule] = await Promise.all([
        import('highlight.js'),
        import('highlightjs-structured-text')
    ]);

    const hljs = hljsModule.default || hljsModule;
    const iecst = iecstModule.default || iecstModule;
    hljs.registerLanguage('iecst', iecst);

    // Предзагрузка стилей
    await import('highlight.js/styles/atom-one-dark.css');

    return hljs;
};

// Ленивый компонент для подсветки
const LazyHighlightContent = lazy(async () => {
    const hljs = await loadHighlight();

    return {
        default: function HighlightContent({ code, language = 'iecst' }) {
            const [highlighted, setHighlighted] = useState('');

            useEffect(() => {
                try {
                    const result = hljs.highlight(code, { language });
                    setHighlighted(result.value);
                } catch (error) {
                    console.error('Highlight error:', error);
                    setHighlighted(code);
                }
            }, [code, language, hljs]);

            return (
                <div dangerouslySetInnerHTML={{ __html: highlighted || code }} />
            );
        }
    };
});

// Основной компонент
export function HighlightedCode({
    code,
    language = 'iecst',
    className = '',
    style = {},
    showLineNumbers = false,
    maxHeight = 'none'
}) {
    const [isClient, setIsClient] = useState(false);

    useEffect(() => {
        setIsClient(true);
    }, []);

    // Стили для pre элемента
    const preStyle = {
        padding: '1rem',
        margin: '1rem 0',
        color: '#a9b7c6',
        background: '#16171a',
        borderRadius: '10px',
        overflow: 'auto',
        maxHeight,
        fontSize: '14px',
        lineHeight: '1.5',
        fontFamily: 'Monaco, "Courier New", monospace',
        ...style
    };

    // На сервере или до гидратации показываем простой код
    if (!isClient) {
        return (
            <pre style={preStyle} className={className}>
                <code>{code}</code>
            </pre>
        );
    }

    // На клиенте используем ленивую загрузку
    return (
        <pre style={preStyle} className={className}>
            <Suspense fallback={
                <code>{code}</code>
            }>
                <LazyHighlightContent code={code} language={language} />
            </Suspense>
        </pre>
    );
}